export const apartmentsGlobalSettings = {
  header: {
    title: "Impostazioni globali",
    sub: "Si applica a <strong>{count} appartamento</strong> del tuo account. | Si applica a <strong>{count} appartamenti</strong> del tuo account.",
    globalChip: "GLOBALE",
  },
  sections: {
    activate: "Attiva il motore di prenotazione",
    payment: "Quando paga l'ospite?",
    hold: "Tempo di blocco",
    request: "Modalità richiesta",
    link: "Link da condividere",
  },
  motor: {
    activeTitle: "Motore attivo",
    inactiveTitle: "Motore inattivo",
    activeDesc: "Gli ospiti possono prenotare direttamente dal tuo link.",
    inactiveDesc: "Le prenotazioni dirette sono disattivate per tutti i tuoi appartamenti.",
    statusOn: "Attivo",
    statusOff: "Inattivo",
  },
  payment: {
    onArrival: {
      name: "Paga all'arrivo",
      hint: "Prenota gratis, paga quando arrivi.",
    },
    online: {
      name: "Paga online",
      hint: "Paga al momento della conferma della prenotazione.",
    },
  },
  common: {
    saving: "Salvataggio…",
    onlyOnlineBadge: "Solo pagamento online",
  },
  hold: {
    desc: "Il calendario viene bloccato mentre l'ospite completa il pagamento.<br>Se non paga entro il tempo impostato, <strong>la disponibilità viene rilasciata automaticamente</strong>.",
  },
  units: {
    min: "min",
    hour: "ora",
    hours: "ore",
  },
  request: {
    enabledTitle: "Richieste attive",
    autoTitle: "Conferma automatica",
    enabledDesc: "L'ospite invia una richiesta. La approvi o la rifiuti tramite WhatsApp.",
    autoDesc: "La prenotazione viene confermata automaticamente una volta completato il pagamento.",
    tagControl: "Controlli tu chi prenota",
    tagWhatsapp: "WhatsApp all'arrivo di una richiesta",
  },
  link: {
    desc: "Lo stesso link per tutti i tuoi appartamenti. Condividilo nella tua bio, nelle campagne o nei messaggi automatici.",
    copyTitle: "Copia",
    viewVisitor: "Visualizza come visitatore",
    shareWhatsapp: "Condividi tramite WhatsApp",
  },
  callout: "Seleziona un appartamento nella barra laterale per impostare singolarmente <strong>Tariffe</strong>, <strong>Promozioni</strong> e <strong>Supplementi</strong>.",
  savebar: {
    unsaved: "Modifiche non salvate a tempo di blocco e modalità richiesta",
    save: "Salva impostazioni",
  },
  toasts: {
    paymentUpdated: "Metodo di pagamento aggiornato.",
    paymentError: "Impossibile salvare il metodo di pagamento.",
    saved: "Impostazioni salvate.",
    saveError: "Impossibile salvare.",
    linkCopied: "Link copiato.",
    copyError: "Impossibile copiare.",
  },
  share: {
    whatsappText: "Ciao 👋 Ecco il link per prenotare: {link}",
  },
};
